/**
 * Fix BO (2026-11-03): borradores de formularios guardados en ESTE celular.
 * En Android, al abrir la cámara del celular el sistema puede cerrar el navegador por falta de memoria;
 * al volver, la página se recarga y se perdía todo lo cargado (novedad, check list). Con esto se guarda
 * mientras se completa y se recupera al volver. Se borra al enviar o a las 12 horas.
 * La clave lleva el id del usuario: en un celular compartido nadie ve el borrador de otro.
 */
const TTL_MS = 12 * 60 * 60 * 1000;
const PREFIX = "invict:draft:";

export function readDraft(key) {
  if (!key) return null;
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return null;
    const d = JSON.parse(raw);
    if (!d || !d.at || Date.now() - d.at > TTL_MS) { localStorage.removeItem(PREFIX + key); return null; }
    return d.data ?? null;
  } catch { return null; }
}

export function writeDraft(key, data) {
  if (!key) return;
  try { localStorage.setItem(PREFIX + key, JSON.stringify({ at: Date.now(), data })); } catch { /* lleno o bloqueado */ }
}

export function clearDraft(key) {
  if (!key) return;
  try { localStorage.removeItem(PREFIX + key); } catch { /* bloqueado */ }
}
